import Temporal from "./temporal";
import Duration from "./duration";
import Special from "./special";
import URL from "hb/lib/url";
import { DEFAULT_TS_INPUT } from "hb/insights/globals";

export function parseTime(fn, str) {
  if (str === "" || str === null) return null;

  let validDate;

  [Duration, Temporal, Special].find((t) => {
    const d = t[fn](str);
    if (d.valid()) {
      validDate = d;
      return true;
    }
  });

  return validDate;
}

export function getTimeFromParam() {
  const [start, end] = URL.getParam("ts")?.split("/") || [];

  return [
    parseTime("fromParam", start) || Duration.fromInput(DEFAULT_TS_INPUT),
    parseTime("fromParam", end),
  ];
}
